import { createGetContractBasedDataFetchSlice } from '@cp-shared-15/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';
import { DealerDetails } from 'cpie-common';

const { reducer, fetchData } = createGetContractBasedDataFetchSlice<DealerDetails, DefaultBusinessMarketApiErrorCode>({
    dataName: 'dealerDetails',
    fetchCallback(link: string) {
        return CpDataApi.get(link).then(response => response.data);
    },
});

export default reducer;
export const fetchDealerDetails = fetchData;
